import { render, staticRenderFns } from "./fillPreQuiz3.vue?vue&type=template&id=1ac4fa2e&scoped=true"
import script from "./fillPreQuiz3.vue?vue&type=script&lang=js"
export * from "./fillPreQuiz3.vue?vue&type=script&lang=js"
import style0 from "./fillPreQuiz3.vue?vue&type=style&index=0&id=1ac4fa2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac4fa2e",
  null
  
)

export default component.exports